<template>
    <div class="product-cate cursor-pointer" >
          <div @click="visible=!visible"  class="font-weight-bold ml-2 mr-2 mt-1 mb-1 d-flex justify-content-between align-content-center" style="color: rgba(38,38,38,.7);font-size: 16px;">
            <span style="margin-top: 3px;font-size: 14px" class="font-weight-bold">
                {{ item.name }}
            </span>
            <ez-icon size="24" icon="ezAr-icon-chevron-down"></ez-icon>
          </div>
          <b-collapse v-model="visible">
            <div class="row mb-2">
              <div
                class="col-3 mt-1 hover-f5"
                :class="{ 'd-none': hide }"
                v-for="{ url, icon, name, description, hide } in item.appLinks"
              >
                <a 
                  target="_blank"
                  :href="url"
                  class="d-flex flex-column align-items-center justify-content-center item "
                >
                  <img :src="icon" width="45" height="45" />
                  {{name }}
                  <span class="text-secondary">{{ description }}</span>
                </a>
               
              </div>
            </div>
      </b-collapse>
        </div>
</template>
<style lang="scss">
    .hover-f5:hover{
        background-color: #f5f5f5;
    }
</style>
<script>
import { defineComponent } from '@vue/composition-api'

    export default defineComponent({
        data(){
            return{
                visible:true,
            }
        },  
        props:{
            index:Number,
            item:Object
        },  
        name:"Collapse"
    })
</script>